// authConfig.js
import { PublicClientApplication } from '@azure/msal-browser'
import type { IPublicClientApplication } from '@azure/msal-browser'

export const isMsalDisabled = process.env.REACT_APP_DISABLE_MSAL === 'true'

const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MS_CLIENT_ID,
    // authority: `https://login.microsoftonline.com/${process.env.REACT_APP_MS_TENANT_ID}`,
    authority: 'https://login.microsoftonline.com/common',
    redirectUri: process.env.REACT_APP_MS_REDIRECT_URL, // or your production URL
  },
  cache: {
    cacheLocation: 'sessionStorage', // or "localStorage"
    storeAuthStateInCookie: false,
  },
}

const noopLogger = {
  clone: () => noopLogger,
  verbose: () => {},
  info: () => {},
  warning: () => {},
  error: () => {},
}

const disabledMsalInstance = {
  initializeWrapperLibrary: () => {},
  getLogger: () => noopLogger,
  addEventCallback: () => 'disabled-msal',
  removeEventCallback: () => {},
  initialize: async () => {},
  handleRedirectPromise: async () => null,
  getAllAccounts: () => [],
  loginRedirect: async () => {},
  logoutRedirect: async () => {},
  acquireTokenSilent: async () => null,
}

const msalInstance = isMsalDisabled
  ? (disabledMsalInstance as unknown as IPublicClientApplication)
  : new PublicClientApplication(msalConfig)

export default msalInstance
